module.exports = __webpack_public_path__ + "img/input-image.f95527e1.png";